import {
  BLUE_YONDER_PROVIDER,
  type DropoffProviderType,
  HAPPY_RETURNS_PROVIDER,
  RETURN_BEAR_PROVIDER,
  VIRTUAL_PROVIDER,
} from "@redotech/redo-return-dropoff-provider-common/dropoff-provider";
import { assertNever } from "@redotech/util/type";
import { CompensationMethod } from "./compensation-method";

export function defaultCompensationMethods(
  provider: DropoffProviderType,
): CompensationMethod[] {
  switch (provider) {
    case VIRTUAL_PROVIDER:
    case RETURN_BEAR_PROVIDER:
    case BLUE_YONDER_PROVIDER:
    case HAPPY_RETURNS_PROVIDER:
      return [
        CompensationMethod.REFUND,
        CompensationMethod.STORE_CREDIT,
        CompensationMethod.EXCHANGE,
      ];
    default:
      assertNever(provider);
  }
}
